export const CHANGE_ADD_ONS = 'change-add-ons';

const changeAddOns = ({ addOnType, addOn, action }) => (
  { type: CHANGE_ADD_ONS, payload: { addOnType, addOn, addOnAction: action } }
);
export default changeAddOns;
